import { FormInput } from "../../../../components/ui/Input/FormInput/FormInput";
import { FormSelect } from "../../../../components/ui/Input/FormSelector/FormSelect";
import { IngredientRegisterViewModel } from "../types/ingredientRegisterView.types";

interface EnvironmentalDataRawFieldsProps {
  vm: IngredientRegisterViewModel;
}

/** RAW-ingredient environmental fields — shown when `derivePackageFlags` resolves `produceIngredient`. */
const EnvironmentalDataRawFields = ({ vm }: EnvironmentalDataRawFieldsProps) => {
  return (
    <div className="tw-grid tw-grid-cols-1 tw-gap-3 md:tw-grid-cols-4">
      <FormSelect
        control={vm.control}
        name="produce_type"
        label="Produce Type"
        options={vm.produceTypeOptions}
        placeholder="Select Produce Type"
        required
        onChange={vm.onProduceTypeChange}
      />
      <FormInput
        control={vm.control}
        name="produceCultivar"
        label="Produce Cultivar"
        placeholder="Produce Cultivar"
      />
      <FormSelect
        control={vm.control}
        name="farming_type"
        label="Farming Type"
        options={vm.farmingTypeOptions}
        placeholder="Select Farming Type"
        onChange={vm.onFarmingTypeChange}
      />
      <FormSelect
        control={vm.control}
        name="field_type"
        label="Field Type"
        options={vm.fieldTypeOptions}
        placeholder="Select Field Type"
        onChange={vm.onFieldTypeChange}
      />
      <FormSelect
        control={vm.control}
        name="country"
        label="Country"
        options={vm.countryOptions}
        placeholder="Select country"
        onChange={value => vm.onCountryChange(Number(value))}
      />
    </div>
  );
};

export default EnvironmentalDataRawFields;
